const { h } = require('preact');
const UserAuth = require('./UserAuth');

function UserLogin() {
  return <UserAuth tab="login" />;
}

module.exports = UserLogin;
